export function filterSortFn(
  items: GoalType[],
  dType: string,
  dates: DatesType,
  gType: string = "AnnualGoal"
): GoalType[] {
  return items
    .filter((g) => g.type === gType)
    .filter((g) =>
      dType === "prev"
        ? g.expected_at <= dates.prev_date_end
        : g.expected_at > dates.prev_date_end
    )
    .sort((a, b) => a.assignee_position - b.assignee_position)
}